import styled from "styled-components";

export const TsrWithBalanceBox = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: 1.5rem;
    ${({theme}) => theme.font.presets.body};

    p:nth-child(odd) {
        color: ${({theme}) => theme.colors.brandSecondary}
    }

    svg {
        margin: 1rem 0;
    }

    width: 25vw;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 82vw;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow + " and " + theme.mediaQuery.landscape} {
        width: 56vw;
    }
`;
